export default "__VITE_ASSET__COQKM7ZL__"